import { useState } from 'react';
import PermissionsSelector from '@/pages/procedures/create/_partials/PermissionsSelector';

export const FORM_VISIBILITY_ID = 'form-visibility';

export default function FormVisibility({ initialSelectedCompanies = [], onSubmit }) {
    const [selectedCompanies, setSelectedCompanies] = useState(initialSelectedCompanies);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.(selectedCompanies);
    };

    return (
        <form id={FORM_VISIBILITY_ID} onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5 scrollbar-hide">
            <PermissionsSelector selected_companies={selectedCompanies} onChange={setSelectedCompanies} />
        </form>
    );
}
